<section class="title-bar content-padding first-item">
    <div class="wrapper">
        <h2 class="left">Proposte di Vendita</h2>
        <br class="clear">
    </div>
</section>
<section id="schedaConsegna" class="content-padding" *ngIf="delivery">
    <div class="narrow-wrapper">
        <div class="delivery-colle-data-box">
            <fieldset>
                <legend>Dettagli della vendita:</legend>

                <div class="col-50 grid-element field">
                    <h3>Stato</h3>
                    <p id="outpuStato" >Da gestire</p>
                </div>

                <div class="col-50 grid-element field">
                    <h3>Data consegna</h3>
                    <p>{{(delivery.actualDate || delivery.deliveryDate) | date:"dd/MM/yyyy" || "---"}}</p>
                </div>

                <div class="col-50 grid-element field">
                    <h3>Fascia oraria Consegna</h3>
                    <p>
                      {{(delivery.fromTime) ? (delivery.fromTime | time: 'HH:mm') : "---"}} - {{(delivery.toTime) ? (delivery.toTime | time: 'HH:mm') : "---"}}
                    </p>
                </div>

                <div class="col-50 grid-element field">
                    <h3>Fascia Orario Ritiro</h3>
                    <p id="outputExpert">{{ delivery?.pickUpTime || "---" }}</p>
                </div>

                <div class="col-100 grid-element field">
                    <div class="flex_wrap"> 
                        <h3 style="margin-bottom: 16px;">Prodotto </h3>
                        <h3 style="margin-bottom: 16px;">Descritzione</h3>
                    </div>
                    <div style="display: flex; justify-content: space-between; " class="prodTable" *ngFor="let dProduct of delivery.deliveryProducts">
                        <div style="width: 250px; cursor: pointer;" (click)="showImage(dProduct)">{{dProduct.product?.name}} </div>
                        <div style="width: 250px;">{{ dProduct.product?.description || "---" }}</div>
                    </div>
                </div>

                <div class="col-50 grid-element field">
                    <h3 style="margin-bottom: 16px;">Prodotto Image</h3>
                    <div *ngFor="let dProduct of delivery.deliveryProducts">
                        <img class="product-image" *ngIf="dProduct?.product?.image" [src]="dProduct?.product?.image" alt="" (click)="openImage(dProduct?.product?.image)" style="cursor: pointer;">
                        <img class="product-image" *ngIf="dProduct?.product?.image === null || dProduct?.product?.image === undefined " src="./assets/img/no-image.jpg" alt="" (click)="openImage('./assets/img/no-image.jpg')">
                    </div>
                </div>

                <div class="col-50 grid-element field">
                    <h3>Prezzo</h3>
                    <p id="outputNoteConsegna" style="white-space: pre-wrap;">{{totalProductPrice}}€</p>
                </div>

                <div class="col-50 grid-element field">
                    <h3 style="margin-bottom: 16px;">Variant</h3>
                    <div class="dlx-value" *ngFor="let dProduct of delivery.deliveryProducts">
                        <span *ngIf="dProduct?.product?.productOptionTitle">
                        <b>({{ dProduct?.product?.productOptionTitle }})</b>
                        </span> 
                        {{ dProduct?.productVariant?.variantName || "---" }}
                    </div>
                </div>

                <div class="col-50 grid-element field">
                    <h3 style="margin-bottom: 16px;">Variant Price</h3>
                    <div class="dlx-value" *ngFor="let dProduct of delivery.deliveryProducts">
                        <span *ngIf="dProduct?.product?.productOptionTitle">
                        <b>({{ dProduct?.product?.productOptionTitle }})</b>
                        </span> 
                        {{ dProduct?.productVariant?.variantPrice || "---" }}
                    </div>
                </div>

                <div class="grid-element-full field">
                    <h3>Note</h3>
                    <p id="outputNoteConsegna" style="white-space: pre-wrap;">{{delivery.notes || "---"}}</p>
                </div>
                <div class="grid-element-full field center">
                    <button type="button" class="btn hvr-shrink center" [disabled]="disableProposeSaleBtn || disablebtn" (click)="acceptSale()">Accetta Vendita</button>
                </div>
                <div class="grid-element-full field center">
                    <button type="button" class="btn hvr-shrink center" [disabled]="disableProposeSaleBtn || disablebtn" (click)="refuseSale()">Rifiuta Vendita</button>
                </div>
            </fieldset>
        </div>
    </div>

</section>

<div *ngIf="showAddressModal && selectedPartner" class="amp-backdrop">
    <div class="amp-box">

        <div class="amp-header">
            <div class="amp-badge">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
                </svg>
                Indirizzi Multipli
            </div>
            <h3 class="amp-title"><span class="amp-partner-name">{{ selectedPartner.businessName }}</span> ha piÃ¹ indirizzi salvati</h3>
            <p class="amp-subtitle">Seleziona un indirizzo di ritiro per proseguire con questo ordine.</p>
        </div>

        <div class="amp-divider"></div>

        <div class="amp-default-block">
            <div class="amp-default-header">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
                </svg>
                <span>Indirizzo Predefinito</span>
                <span class="amp-default-tag">Predefinito</span>
            </div>
            <p class="amp-default-address">{{ selectedPartner.address }}</p>
        </div>

        <div class="amp-section-label">Seleziona un indirizzo alternativo</div>

        <div class="amp-list">
            <label
                *ngFor="let addr of partnerPickupAddresses"
                class="amp-item"
                [class.amp-item--selected]="selectedPickupAddress === addr"
                [class.amp-item--disabled]="isConfirming">
                <input
                    type="radio"
                    [value]="addr"
                    [(ngModel)]="selectedPickupAddress"
                    [disabled]="isConfirming">
                <div class="amp-radio-dot">
                    <div class="amp-radio-inner"></div>
                </div>
                <div class="amp-address-text">
                    <span class="amp-address-label">{{ addr }}</span>
                </div>
                <svg class="amp-pin-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
                </svg>
            </label>
        </div>

        <div class="amp-footer">
            <button type="button" class="amp-btn amp-btn--cancel" (click)="handleAddressModal()" [disabled]="isConfirming">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                Annulla
            </button>
            <button type="button" class="amp-btn amp-btn--confirm" (click)="confirmPickupAddress()" [disabled]="isConfirming || !selectedPickupAddress">

                <span *ngIf="isConfirming" class="amp-spinner"></span>

                <ng-container *ngIf="!isConfirming">
                    Conferma Indirizzo
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </ng-container>

                <ng-container *ngIf="isConfirming">
                    Caricamento...
                </ng-container>
            </button>
        </div>
    </div>
</div>